import { LogLevel } from "./logger";
export const createAnalyticsAdapter = ({ adapters, }) => {
    /** The context for user identification */
    let sessionContext = {};
    const _adapters = new Set(adapters);
    const emit = async (...events) => {
        return Promise.allSettled(Array.from(_adapters)
            .map(adapter => {
            try {
                return adapter.emit(...events);
            }
            catch (e) {
                console.error("could not emit event to the analytics adapter", e);
            }
        })
            .filter(res => res instanceof Promise)).then(response => {
            if (response?.some(res => res.status === "rejected")) {
                console.warn("failed to emit some events to the analytics adapter", response);
            }
        });
    };
    const log = (level, message) => {
        _adapters.forEach(adapter => {
            try {
                adapter.log(level, message);
            }
            catch { }
        });
    };
    const viewPage = (pageName, params) => {
        _adapters.forEach(adapter => {
            try {
                adapter.viewPage(pageName, params);
            }
            catch (e) {
                console.error("could not emit event to the analytics adapter", e);
                log(LogLevel.ERROR, `could not emit event to the analytics adapter: ${e.message}`);
            }
        });
    };
    const updatePage = (params) => {
        _adapters.forEach(adapter => {
            try {
                adapter.updatePage(params);
            }
            catch (e) {
                console.error("could not update the page", e);
                log(LogLevel.ERROR, `could not update the page with the analytics adapter: ${e.message}`);
            }
        });
    };
    const unloadPage = () => {
        _adapters.forEach(adapter => {
            try {
                adapter.unloadPage();
            }
            catch (e) {
                console.error("could not unload the page", e);
                log(LogLevel.ERROR, `could not unload the page with the analytics adapter: ${e.message}`);
            }
        });
    };
    /** Identify the user with any added context */
    const identify = async (params) => {
        return Promise.all([..._adapters].map(adapter => {
            try {
                adapter.identify({ ...params, ...sessionContext });
            }
            catch (e) {
                console.error("could not identity the user with the analytics adapter", e);
                log(LogLevel.ERROR, `could not unload the page with the analytics adapter: ${e.message}`);
            }
        })).then(() => { });
    };
    const anonymize = async () => {
        return Promise.all([..._adapters].map(adapter => {
            try {
                adapter.anonymize();
            }
            catch (e) {
                console.error("could not anonymize the user with the analytics adapter", e);
                log(LogLevel.ERROR, `could not anonymize the user with the analytics adapter: ${e.message}`);
            }
        })).then(() => { });
    };
    /** Add to the context for user identification */
    const addSessionContext = (newContext) => {
        sessionContext = { ...sessionContext, ...newContext };
    };
    return {
        anonymize,
        emit,
        identify,
        log,
        unloadPage,
        updatePage,
        viewPage,
        addSessionContext,
    };
};
export * from "./adapter/analyticsAdapter";
export * from "./adapter/fullStoryAdapter";
export * from "./adapter/intercomAdapter";
export * from "./adapter/sentryAdapter";
export * from "./event/accountEvents";
export * from "./event/curriculumEvents";
export { mapAnalyticsDomainToInteractionName, } from "./event/domain";
export * from "./event/eventBase";
export * from "./event/digitalEventEvents";
export * from "./event/customerLibraryEvents";
export * from "./event/ebookEvents";
export * from "./event/licenseEvents";
export * from "./event/videoEvents";
export * from "./event/studyEvents";
export * from "./event/readingPlanEvents";
export * from "./event/systemEvents";
export * from "./logger";
//# sourceMappingURL=index.js.map